// Configuration file for Restaurar Portugal website
export const config = {
  // Website title
  title: "Restaurar Portugal",
  
  // Mission statement - modify this text as needed
  mission: "Restaurar Portugal para as gerações futuras.",
  
  // Other configurable items can be added here
  description: "Por um Portugal para os Portugueses",
  buttonText: "Contacto",

  ourMission: "A nossa missão"
};